import { useState } from "react";
import {
  Alert,
  Box,
  Button,
  CircularProgress,
  Divider,
  IconButton,
  Modal,
  Paper,
  Tab,
  Tabs,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

type Props = {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  title: string;
  methodList: {
    icon: React.ReactNode;
    title: string;
    onClick: () => void;
    disabled?: boolean;
  }[];
};

export const MethodModal = ({
  isOpen,
  setIsOpen,
  title,
  methodList,
}: Props) => {
  return (
    <Modal open={isOpen}>
      <Box
        sx={{
          position: "absolute",
          bottom: 0,
          left: 0,
          right: 0,
          bgcolor: "background.paper",
        }}
      >
        <Box
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          sx={{ mx: 2 }}
        >
          <Typography
            id="modal-modal-title"
            variant="h6"
            component="h2"
            color="primary"
            sx={{
              textAlign: "left",
              my: 1,
            }}
          >
            {title}
          </Typography>
          <IconButton onClick={() => setIsOpen(false)} aria-label="閉じる">
            <CloseIcon />
          </IconButton>
        </Box>
        {methodList.map((method) => (
          <Button
            variant="outlined"
            onClick={() => {
              method.onClick();
            }}
            disabled={method.disabled}
            sx={{ color: "#000", m: 1, mb: 4, p: 0 }}
          >
            <Box
              width={80}
              display="flex"
              alignItems="center"
              flexDirection="column"
              sx={{
                pt: 2,
                pb: 2,
                px: 0,
                mx: 1,
              }}
            >
              {method.icon}
              <Typography>{method.title}</Typography>
            </Box>
          </Button>
        ))}
      </Box>
    </Modal>
  );
};
